/**
 * Created by mac on 3/23/17.
 */

const WordGame = function (level, options) {
    options = options || {};

    GameBase.call(this, level, options);

    this.setupMissions();

    this.counter.registerStage(100, this.discoverOpened.bind(this));
    this.counter.registerStage(110, this.saveStable.bind(this));
    this.counter.registerStage(200, this.showExclamation.bind(this));
    this.counter.registerStage(800, this.checkComplete.bind(this));
    this.counter.registerStage(801, this.checkOneWordLeft.bind(this));
    this.counter.registerStage(900, this.showInterstitial.bind(this));
    if (this.scoreBar) {
        this.counter.registerStage(901, this.runScoreBarReward.bind(this));
    }
    this.counter.registerStage(2000, this.resetStatus.bind(this));

    const save = this.savedGame;

    if (save.timeStart === undefined) {
        this.needSave = true;
    }

    save.words = (save.words || []).map((word) => word.toLowerCase());

    save.extra = (save.extra || []).map((word) => word.toLowerCase());

    this.emptySave = save.empty;

    this.hintBooster = cleverapps.boosters.getBoosterById(cleverapps.Boosters.TYPE_HINT);
    this.openLetterBooster = cleverapps.boosters.getBoosterById(cleverapps.Boosters.TYPE_OPEN_LETTER);

    this.board = new cleverapps.Board(this, save.words, save.hints);

    this.keypad = new Keypad(this, save);
    this.keypad.on("attempt", this.onAttempt.bind(this));

    this.extra = new cleverapps.Extra(this.levelContent.extra, save.extra);
    this.extra.onChangedListener = this.storeSave.bind(this);

    this.current = new cleverapps.Current(this, this.keypad);

    this.streakCounter = 0;

    let competitionOptions;
    if (cleverapps.isRumble()) {
        competitionOptions = Competition.optionsForKnockoutGame(this);
    }

    if (competitionOptions) {
        this.competition = new Competition(competitionOptions);
        this.on("beforeStartActions", this.competition.start.bind(this.competition), this);
        this.competition.on("lose", () => {
            if (!this.board.isComplete()) {
                this.lose();
            }
        });
    }

    if (["scramble"].indexOf(cleverapps.config.name) !== -1) {
        this.currentHighlighter = new CurrentHighlighter(this, save);
    }

    if (this.needSave) {
        this.storeSave();
    }

    this.hintNotification = new HintNotification(this);
    
    if (this.kingsCupMission) {
        new KingsCupButterfly();
    }

    if (this.needAddBonusTimer()) {
        this.bonusTimer = new cleverapps.CountDown(cleverapps.parseInterval(WordGame.BONUS_LEVEL_DURATION));
        this.bonusTimer.onFinish = function () {
            this.win();
        }.bind(this);
    }
};

Game = WordGame;

WordGame.prototype = Object.create(GameBase.prototype);
WordGame.constructor = WordGame;

WordGame.prototype.setupMissions = function () {
    if (!this.level.isRegular() || this.hasDanger() || this.level.isBonus()) {
        return;
    }

    const kingsCupMission = cleverapps.missionManager.findByType(Mission.TYPE_KINGSCUP);
    if (kingsCupMission && kingsCupMission.isRunning() && kingsCupMission.logic.isUnlocked()) {
        this.kingsCupMission = kingsCupMission;
    }

    const lightingRushMission = cleverapps.missionManager.findByType(Mission.TYPE_LIGHTNING_RUSH);
    if (lightingRushMission && lightingRushMission.isRunning() && lightingRushMission.logic.isActiveState()) {
        this.lightingRushMission = lightingRushMission;
    }
};

WordGame.prototype.storeSave = function () {
    if (!cleverapps.isRumble()) {
        cleverapps.GameSaver.save(this.getInfo(), this.level.episodeNo, this.level.levelNo);
    }
};

WordGame.prototype.needAddFlyingAd = function () {
    return !this.needAddBonusTimer();
};

WordGame.prototype.needAddBonusTimer = function () {
    return this.level.isBonus() && cleverapps.config.subtype !== "stacks";
};

WordGame.prototype.loadSave = function () {
    if (!cleverapps.isRumble()) {
        const stored = cleverapps.GameSaver.load(this.level.episodeNo, this.level.levelNo);

        if (stored && Object.keys(stored).length > 0) {
            return stored;
        }
    }
};

WordGame.prototype.saveStable = function () {
    if (this.outcome === GameBase.OUTCOME_UNKNOWN) {
        this.storeSave();
    }
};

WordGame.prototype.showExclamation = function () {
    if (this.needShowExclamation && !this.board.isComplete()) {
        cleverapps.exclamation.show(PseudoRandom.GET().mathChoose(cleverapps.exclamation.getCongratulations()));
        delete this.needShowExclamation;
    }
};

WordGame.prototype.onAttempt = function (letters) {
    this.begin(true);

    const word = this.keypad.combineWord(letters);
    const status = this.analyze(word);

    this.keypad.status(status, letters);
    this.current.status(status, word);

    if (status === WordGame.STATUSES.BOARD) {
        this.streakCounter++;
        this.discover(word, letters);
        cleverapps.userStatus.reportUserAction();
    } else {
        this.streakCounter = 0;
    }

    if (status === WordGame.STATUSES.EXTRA) {
        this.extra.discover(word);
        cleverapps.userStatus.reportUserAction();
    }

    if (status === WordGame.STATUSES.EXTRA_FOUND) {
        this.extra.wordFound(word);
    }

    if (status === WordGame.STATUSES.BOARD_FOUND) {
        this.board.alreadyDiscovered(word);
    }

    if (status === WordGame.STATUSES.WRONG) {
        this.trigger("WrongWord_Booster");
    }

    this.status = status;
};

WordGame.prototype.discover = function (word, letters) {
    cleverapps.eventBus.trigger("discover_word", {
        letters: cleverapps.unique(word.split("")),
        long: word.length >= 7
    });

    this.board.discover(word, letters);

    if (this.streakCounter >= 2) {
        this.needShowExclamation = true;
        this.streakCounter = 0;
    }

    this.keypad.markDiscovered(word, letters);

    if (cleverapps.config.subtype === "stacks") {
        this.pendingBonusBlocks = this.calculatePendingBonusBlocks();
    }

    if (this.competition) {
        this.competition.updatePlayerResult(Competition.PLAYER_ID, this.board.countDiscoveredWords());
    }

    if (this.updateCurrentHighlighter) {
        this.updateCurrentHighlighter();
    }
   
    cleverapps.tutorial.trigger("discover_word");
    this.trigger("openWord");
};

WordGame.prototype.getDailyCupStars = function () {
    return this.extra.getAllFoundWords().length + Object.keys(this.board.foundWordsSet).length;
};

WordGame.prototype.showStartGameMessage = function (f, silent) {
    let message;
    if (cleverapps.isRumble() && cleverapps.knockoutGame.rumble.getCurrentRound().isLast()) {
        message = "message.lastRound";
    } else if (this.level.isBonus() && cleverapps.config.subtype === "stacks") {
        message = "message.bonusLevel";
    } else if (this.level.isHard()) {
        message = "message.hardLevel";
    } else if (this.level.isTricky()) {
        message = "message.trickyLevel";
    }

    if (message && !silent) {
        this.showMessage(message, f);
    } else {
        f();
    }
};

WordGame.STATUSES = {
    BOARD: 0,
    BOARD_FOUND: 1,
    EXTRA: 2,
    EXTRA_FOUND: 3,
    WRONG: 4,
    SHORT: 5
};

WordGame.BOARD_COIN = 1;

WordGame.prototype.stop = function () {
    cleverapps.competitionStatistics.onGameStop(this);
    this.hintBooster.clear();
    this.keypad.stop();

    if (this.competition) {
        this.competition.stop();
    }

    this.hintNotification.stop();
    this.current.clear();

    if (this.bonusTimer) {
        this.bonusTimer.stop();
    }

    GameBase.prototype.stop.call(this);
};

WordGame.prototype.getMinWordLength = function () {
    if (["stacks"].indexOf(cleverapps.config.subtype) !== -1) {
        if (cleverapps.settings.language === "ja" || cleverapps.settings.language === "ko") {
            return 2;
        }
        return 3;
    }
    let minLength = this.levelContent.words[0].length;

    for (let i = 0; i < this.levelContent.words.length; i++) {
        if (this.levelContent.words[i].length < minLength) {
            minLength = this.levelContent.words[i];
        }
    }
    return minLength;
};

WordGame.prototype.analyze = function (word) {
    if (word.length < this.getMinWordLength()) {
        return WordGame.STATUSES.SHORT;
    }

    if (this.board.contains(word)) {
        return this.board.analyze(word);
    }

    if (this.extra.contains(word) && !cleverapps.tutorial.isActive()) {
        return this.extra.analyze(word);
    }

    return WordGame.STATUSES.WRONG;
};

WordGame.prototype.discoverOpened = function () {
    let letters;

    if (cleverapps.config.subtype === "stacks") {
        letters = this.keypad.findOpenedWord();
    } else {
        letters = this.board.findNewlyOpenedWord();
    }

    if (letters) {
        this.onAttempt(letters);
    }
};

WordGame.prototype.checkComplete = function () {
    if (this.board.isComplete() && this.outcome === GameBase.OUTCOME_UNKNOWN) {
        this.win();
    }
};

WordGame.prototype.showInterstitial = function () {
    if (this.status === WordGame.STATUSES.WRONG && !this.level.isBonus()) {
        cleverapps.focusManager.display({
            focus: "showInterstitialWrong",
            action: function (f) {
                cleverapps.rewardedAdsManager.showInterstitial({
                    limit: AdsLimits.TYPES.INTERSTITIAL,
                    placement: AdsLimits.TYPES.INTERSTITIAL_INACTIVE
                }, f);
            }
        });
    }
};

WordGame.prototype.resetStatus = function () {
    this.status = undefined;
};

WordGame.prototype.getInfo = function () {
    const info = GameBase.prototype.getInfo.call(this);

    return Object.assign(info, {
        words: this.board.getAllFoundWords(),
        hints: this.board.calcHints(),
        extra: this.extra.getAllFoundWords(),
        timeStart: this.timer.getStartTime()
    });
};

WordGame.prototype.getInitialInfo = function () {
    this.needSave = true;
    return {
        words: [],
        extra: [],
        hints: [],
        timeStart: Date.now(),
        empty: true
    };
};

WordGame.prototype.addMissionReward = function (...args) {
    GameBase.prototype.addMissionReward.apply(this, args);
    this.storeSave();
};

if (cleverapps.config.debugMode) {
    WordGame.prototype.discoverDebug = function (player) {
        if (player.player) {
            const words = this.board.getUndiscoveredWords();
            if (words.length > 0) {
                this.keypad.trigger("attempt", words[0]);
            }
        } else {
            this.competition.updatePlayerResult(player.id, player.amount + 1);
        }
    };
}

WordGame.prototype.totalItemsToSolve = function () {
    return this.board.countTotalWords();
};

WordGame.prototype.showScreen = function (f, silent) {
    cleverapps.focusManager.compound(f, [
        function (f) {
            this.board.showUp(f, silent);
            this.keypad.showUp(() => {}, silent);
        }.bind(this)
    ]);
};

WordGame.prototype.checkOneWordLeft = function () {
    if (this.board.isComplete() || this.lastWordFound) {
        return;
    }

    const words = this.board.getUndiscoveredWords();
    if (words.length === 1) {
        this.lastWordFound = true;
        this.board.trigger("lastWord", this.board.listWordIndexes(words[0]));
    }
};

WordGame.BONUS_LEVEL_DURATION = "2 minutes";